import React from "react";

import Customer from "../../../models/Customer";
import { CustomerRating } from "../../../models/CustomerRating";
import { TagType } from "../../../models/Organisation";
import CustomerHeader from "./CustomerHeader";

const mockTagTypes = [
	{ key: "vip", name: { sv: "VIP" }, color: "#f59e0b" },
	{ key: "public-sector", name: { sv: "Offentlig sektor" }, color: "#3b82f6" },
	{ key: "framework-agreement", name: { sv: "Ramavtal" }, color: "#10b981" },
] as TagType[];

const mockCustomer = {
	id: "demo-customer",
	name: "Norrlands Bemanning AB",
	customerNumber: "10042",
	phoneNumber: "0812345678",
	active: true,
	privatePerson: false,
	contract: { id: "contract-1", name: "Standardavtal 2026 – Vård & Omsorg" },
	metadata: { created: "2024-03-11T09:15:00.000Z" },
	tags: [{ key: "vip" }, { key: "public-sector" }, { key: "framework-agreement" }],
} as unknown as Customer;

const mockRating = { avg: 4.3, count: 12 } as CustomerRating;

const CustomerHeaderExample: React.FC = () => {
	return (
		<div className="flex flex-col gap-8">
			<div className="rounded-md border border-gray-200 p-6">
				<CustomerHeader
					customer={mockCustomer}
					rating={mockRating}
					tagTypes={mockTagTypes}
					onToggleTag={() => {}}
					onUploadProfilePicture={() => {}}
				/>
			</div>

			<div className="rounded-md border border-gray-200 p-6">
				<p className="mb-4 text-sm text-muted-foreground">
					Minimal — inactive private person, no contract, no ratings.
				</p>
				<CustomerHeader
					customer={
						{
							id: "demo-customer-2",
							name: "Anna Karlsson",
							customerNumber: "10099",
							phoneNumber: "",
							active: false,
							privatePerson: true,
						} as unknown as Customer
					}
					onUploadProfilePicture={() => {}}
				/>
			</div>
		</div>
	);
};

export default CustomerHeaderExample;
